import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/pages/RequestDetails'),
      children: [
        {
          path: ':id',
          name: 'requestDetails',
          component: () => import('@/components/pages/RequestDetails'),
        },
      ],
    },
  ],
});
